import genericModels from './genericModels';
import makes from './makes';
import { savedFilter } from './savedFilter';

export default {
	genericModels,
	makes,
	savedFilters: [savedFilter],
};
